import { useMemo } from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import DataTable from "@accredo/fe-shared/components/DataTable.jsx";
import PaymentImportStatusBadge from "../PaymentImportStatusBadge.jsx";
import { getEuro } from "@accredo/fe-shared/services/formatService.js";

export default function BookingExportPaymentsTable({
  payments,
  renderDetailPanel,
  enableExpandAll,
  initialState,
  enableTopToolbar = true,
  enablePagination = true,
}) {
  const columns = useMemo(
    () => [
      { accessorKey: "remitter", header: "Absender", size: 180 },
      { accessorKey: "iban", header: "IBAN", size: 200 },
      { accessorKey: "bic", header: "BIC", size: 120 },
      { accessorKey: "description", header: "Beschreibung", size: 220 },
      {
        accessorKey: "amount",
        header: "Betrag",
        size: 120,
        muiTableHeadCellProps: { align: "right" },
        Cell: ({ cell }) => (
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            {getEuro(cell.getValue())}
          </Typography>
        ),
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 120,
        Cell: ({ cell }) => <PaymentImportStatusBadge status={cell.getValue()} />,
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={payments}
      manualSorting={false}
      enableGlobalFilter={false}
      enableColumnFilters={false}
      renderDetailPanel={renderDetailPanel}
      enableExpandAll={enableExpandAll}
      initialState={initialState}
      enableTopToolbar={enableTopToolbar}
      enablePagination={enablePagination}
    />
  );
}

BookingExportPaymentsTable.propTypes = {
  payments: PropTypes.array.isRequired,
  renderDetailPanel: PropTypes.func,
  enableExpandAll: PropTypes.bool,
  initialState: PropTypes.object,
  enableTopToolbar: PropTypes.bool,
  enablePagination: PropTypes.bool,
};
